import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ActivitiesService } from '../activities/activities.service';
import { AuthService } from '../shared/auth.service';
import { TakerService } from '../shared/taker.service';
import { Meta, Title } from '@angular/platform-browser';
import { Activity } from '../activities/activity.model';
import { finalize } from 'rxjs/operators';
import { ExperienceSearchComponent } from 'src/app/shared/experience-search/experience-search.component';
import { ActivityCardComponent } from 'src/app/shared/activity-card/activity-card.component';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { LocationService } from 'src/app/shared/locations/location.service';
import { environment } from 'src/environments/environment';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@Component({
  selector: 'app-destinations',
  standalone: true,
  imports: [
    ExperienceSearchComponent,
    TranslateModule,
    ActivityCardComponent,
    RouterLink,
    CommonModule,
    InfiniteScrollModule
  ],
  templateUrl: './destinations.component.html',
  styleUrls: [
    './destinations.component.scss',
    '../../../../node_modules/keen-slider/keen-slider.min.css',
  ],
})
export class DestinationsComponent implements OnInit {
  @ViewChild('lastSliderRef', { static: false })
  lastSliderRef!: ElementRef<HTMLElement>;
  @ViewChild('sliderRef', { static: false })
  sliderRef!: ElementRef<HTMLElement>;
  @ViewChild('providersSliderRef', { static: false })
  providersSliderRef!: ElementRef<HTMLElement>;

  API_URL = environment.apiUrl;

  // Last slider (zones) properties
  lastSlider: KeenSliderInstance = null;
  lastCurrentSlide: number = 0;
  lastDotHelper: Array<Number> = [];
  lastSlidesLength: number = 0;
  lastZonesIndex = 0;

  // Main activities slider properties
  slider: KeenSliderInstance = null;
  currentSlide: number = 0;
  dotHelper: Array<Number> = [];
  slidesLength: number = 0;

  // Providers slider properties
  providersSlider: KeenSliderInstance = null;
  currentProvidersSlide: number = 0;
  providersSliderDotHelper: Array<Number> = [];

  parentVariable: string;
  public expandedIndex = -1;
  public originalActivities: Activity[];
  activities = [];
  isAlertShown = false;
  throttle = 150;
  scrollDistance = 0.1;
  page = 1;
  total = 0;
  loading = false;
  filtered = false;
  filterZone: any;
  notEmptyExperience = true;
  notScrolly = true;

  location: any = '';

  locationObj: any;

  locationActivities: any;
  locationsTotalActivities: 0;

  locationsZones: any;
  activity: any;

  constructor(
    private activityService: ActivitiesService,
    private locationService: LocationService,
    private router: Router,
    private titleService: Title,
    private takerService: TakerService,
    public authService: AuthService,
    public translate: TranslateService,
    private meta: Meta,
    private renderer2: Renderer2,
    private cdref: ChangeDetectorRef
  ) {
    // https://api.venntur.com/locations?name=mallorca
  }

  ngOnInit(): void {
    console.log('CURRENT LANG?: ', this.translate.currentLang);
    this.meta.addTags([
      { name: 'description', content: 'test' },
      { name: 'lang', content: 'es' },
      { name: 'robots', content: 'index, follow' },
      { property: 'og:title', content: 'test' },
      { property: 'og:description', content: 'test' },
      {
        property: 'og:image',
        content: 'https://venntur.com/assets/venntur-isotype-70.png',
      },
      { property: 'og:url', content: 'https://venntur.com/' },
      { property: 'og:site_name', content: 'Venntur' },
    ]);

    this.loading = true;
    this.filtered = false;

    this.location =
      this.router['rawUrlTree'].root.children.primary.segments[2].path;

    this.titleService.setTitle(
      'Experiencias en ' + this.location + ' | Venntur'
    );
    this.router['rawUrlTree'].queryParams['page'] = this.page;

    setTimeout(() => {
      if (this.location === 'españa') {
        this.translate.get('locations.spain').subscribe((translations) => {
          this.locationObj = {
            name: translations.name,
            subtitle: translations.subtitle,
            description: translations.description,
          };
  
          this.locationService.getActiveLocations().subscribe((zones) => {
            this.locationsZones = zones['hydra:member'];
            this.initializeAllSliders();
          });
        });
      } else {
        this.locationService
          .getLocationByName(this.location, this.translate.getDefaultLang())
          .subscribe((locationActual) => {
            this.locationObj = locationActual['hydra:member'][0];
  
            this.locationService
              .getLocationZones(this.locationObj['id'])
              .subscribe((zones) => {
                this.locationsZones = zones['hydra:member'];
                this.initializeAllSliders();
              });
          });
      }
      
      this.activityService
        .getActivities(
          { location: this.location === 'españa' ? '' : this.location, page: 1 },
          this.translate.getDefaultLang()
        )
        .pipe(finalize(() => (this.loading = false)))
        .subscribe((activities) => {
          this.total = activities['hydra:totalItems'];
          this.activities = activities['hydra:member'];
          this.locationActivities = activities['hydra:member'];
          this.locationsTotalActivities = activities['hydra:totalItems'];
        });
    }, 500);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initializeAllSliders();
    }, 100); // Give time for DOM updates
  }

  getHeroBannerImage(locationObj: any): string {
    if (this.location === 'españa') {
      return 'assets/images/spain.webp';
    }

    if (!locationObj) {
      return;
    }

    return `https://api.venntur.hub2b.travel${locationObj.media[0].contentUrl}`
    // : 'https://venntur.com/assets/experience/files/65ae460178ac4907716421.webp';
    /*? `https://dev.venntur.com/assets/activities/files/${locationObj.image[0].contentUrl}`
      : 'https://venntur.com/assets/activities/files/65ae460178ac4907716421.webp'; */
  }

  initializeAllSliders() {
    // Initialize providers slider
    if (this.providersSliderRef) {
      this.providersSlider = new KeenSlider(
        this.providersSliderRef.nativeElement,
        {
          initial: this.currentProvidersSlide,
          loop: true,
          slideChanged: (s) => {
            this.currentProvidersSlide = s.track.details.rel;
            this.cdref.detectChanges();
          },
          breakpoints: {
            '(min-width: 0px)': {
              slides: { perView: 1.2, spacing: 10 },
            },
            '(min-width: 413px)': {
              slides: { perView: 1.5, spacing: 15 }, // Show 1.5 cards on Android compact view
            },
            '(min-width: 768px)': {
              slides: { perView: 2, spacing: 20 },
            },
            '(min-width: 992px)': {
              slides: { perView: 3, spacing: 25 },
            },
            '(min-width: 1200px)': {
              slides: { perView: 4, spacing: 30 },
            },
          },
        }
      );

      this.providersSliderDotHelper = Array.from({
        length: this.providersSlider.track.details
          ? Math.ceil(this.providersSlider.track.details.slides.length)
          : 0,
      });
    }

    this.loadSliderZones();
    this.loadSlider();

    this.cdref.detectChanges();
  }

  loadSliderZones() {
    if (this.lastSliderRef) {
      this.lastSlider = new KeenSlider(this.lastSliderRef.nativeElement, {
        initial: this.lastCurrentSlide,
        loop: true,
        slideChanged: (s) => {
          this.lastCurrentSlide = s.track.details.rel;
          this.cdref.detectChanges();
        },
        breakpoints: {
          '(min-width: 0px)': {
            slides: { perView: 2.5, spacing: 5 },
          },
          '(min-width: 768px)': {
            slides: { perView: 5.5, spacing: 5 },
          },
          '(min-width: 992px)': {
            slides: { perView: 5.5, spacing: 5 },
          },
        },
        slides: { perView: 2 },
      });
      this.lastDotHelper = Array.from({
        length: Math.ceil(this.lastSlider.track.details.slides.length),
      });
      this.lastSlidesLength = Math.ceil(
        this.lastSlider.track.details.slides.length
      );
      this.cdref.detectChanges();
    }
  }

  loadSlider() {
    if (this.sliderRef) {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        initial: this.currentSlide,
        loop: true,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
          this.cdref.detectChanges();
        },
        breakpoints: {
          '(min-width: 0px)': { slides: { perView: 1, spacing: 0 } },
          '(min-width: 768px)': { slides: { perView: 2, spacing: 0 } },
          '(min-width: 992px)': { slides: { perView: 3, spacing: 0 } },
        },
        slides: { perView: 1 },
      });

      this.dotHelper = Array.from({
        length: this.providersSlider.track.details
          ? Math.ceil(this.providersSlider.track.details.slides.length)
          : 0,
      });
      this.cdref.detectChanges();
    }
  }

  filterByZone(zone: any) {
    this.loading = true;

    if (!zone || zone === '') {
      this.filtered = false;
      this.filterZone = '';
      this.total = this.locationsTotalActivities;
      this.activities = this.locationActivities;

      this.reinitializeSlider();
      this.loading = false;
      return;
    }

    this.activityService
      .getActivitiesByZone(
        zone,
        this.translate.currentLang ?? this.translate.getDefaultLang()
      )
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((activities) => {
        this.filtered = true;
        this.filterZone = zone;
        this.total = activities['hydra:totalItems'];
        this.activities = this.formatActivitiesForSlider(
          activities['hydra:member']
        );
        this.reinitializeSlider();
      });
  }

  formatActivitiesForSlider(activities: any[]): any[] {
    const requiredSlides = 3;
    if (activities.length >= requiredSlides) {
      return activities;
    }

    const placeholders = Array(requiredSlides - activities.length).fill({
      placeholder: true,
    });
    return [...activities, ...placeholders];
  }

  reinitializeSlider() {
    if (this.slider) {
      this.slider.destroy();
    }
    if (this.providersSlider) {
      this.providersSlider.destroy();
    }
    if (this.lastSlider) {
      this.lastSlider.destroy();
    }

    setTimeout(() => {
      this.initializeAllSliders();
    });
  }

  capitalize(str: string): string {
    if (str.length === 0) {
      return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  capitalizeFirstLetter(name: string): string {
    if (!name) return '';
    return name
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  toUrlFriendly(text: string): string {
    return text.trim().replace(/\s+/g, '%20');
  }

  onScroll() {
    this.loading = true;
    if (this.notScrolly && this.notEmptyExperience) {
      this.notScrolly = false;
      setTimeout(() => {
        this.loadNextExperience();
      }, 500);
    } else {
      this.loading = false;
    }
  }

  loadNextExperience() {
    // this.router['rawUrlTree'].queryParams['page'] = ++this.page;
    ++this.page;
    let updatedUrl;
    if (this.parentVariable) {
      updatedUrl = this.parentVariable.replace(/page=\d+/, `page=${this.page}`);
    } else if (this.router['rawUrlTree'].queryParams['localidad']) {
      this.router['rawUrlTree'].queryParams['page'] = this.page;
      updatedUrl = this.router['rawUrlTree'];
    } else {
      updatedUrl = '?page=' + this.page;
    }
    if (this.location != 'españa') {
      updatedUrl += '&location=' + this.location;
    }

    let params: any = new URL('https://app.venntur.com/' + updatedUrl).searchParams;
    this.notScrolly = true;
    this.notEmptyExperience = true;
    if (this.activities.length < this.total) {
      this.activityService
        .getActivitiesByUrl(params, this.translate.getDefaultLang())
        .pipe(finalize(() => (this.loading = false)))
        .subscribe((activities) => {
          this.total = activities['hydra:totalItems'];
          this.activities = this.activities.concat(activities['hydra:member']);
        });
      // let i;
      // const length = this.experiences.length;
      // const experiencePerPage = 9;
      // const experienceToLoad = this.originalExperiences.length - length;

      // if ( experienceToLoad >= experiencePerPage ) {
      //   for (i = length; i <= length + experiencePerPage; i++) {
      //     this.experiences.push(this.originalExperiences[i]);
      //   }
      // } else {
      //   for (i = length; i <= length + experienceToLoad - 1; i++) {
      //     this.experiences.push(this.originalExperiences[i]);
      //   }
      // }
    } else {
      this.loading = false;
    }
  }

  changeParentVariable(newVariable: string) {
    var convertedZone = this.filterZone
      ? this.toUrlFriendly(this.filterZone)
      : '';

    this.parentVariable =
      newVariable +
      '&location=' +
      this.location +
      (this.filterZone ? '&zone=' + convertedZone : '');

    const params = new URL('https://venntur.com/' + this.parentVariable)
      .searchParams;

    console.log('PARENT V + params: ', this.parentVariable, params);

    this.activityService
      .getActivitiesByUrl(params, this.translate.getDefaultLang())
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((activities) => {
        this.total = activities['hydra:totalItems'];
        this.activities = activities['hydra:member'];
        this.page = 1;
      });
  }

  ngOnDestroy() {
    if (this.lastSlider) {
      this.lastSlider.destroy();
    }
    if (this.slider) {
      this.slider.destroy();
    }
    if (this.providersSlider) {
      this.providersSlider.destroy();
    }
  }
}
